import { Navigate, Outlet } from "react-router-dom";
import { isValidSession } from "../tools/jwtToken/jwtToken";

const ProtectedRoute = () =>
  isValidSession() ? <Outlet /> : <Navigate to="/login" />;

export default ProtectedRoute;
